import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { FieldTextInput } from 'Components/FormFields';
import UIButton from 'Components/UIComponents/UIButton';
import { useIsMobile } from 'Hooks/Common';
import { composeValidators } from 'Utils/functions';
import {
  maxLength100,
  notOnlySpaces,
  required,
  titleNotUrlProtocol,
} from 'Utils/validation';

interface LandingSetTitleFormProps {
  buttonTitle?: string;
  isLoading?: boolean;
}

const LandingSetTitleForm = ({
  buttonTitle = 'Sign Document',
  isLoading,
}: LandingSetTitleFormProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={classNames('sign-up-landing__upload-wrapper', { mobile: isMobile })}>
      <p className="sign-up-landing__upload-header">One more thing</p>
      <Field
        name="title"
        label="Document title"
        component={FieldTextInput}
        placeholder="Enter the title"
        validate={composeValidators<string>(
          required,
          notOnlySpaces,
          maxLength100,
          titleNotUrlProtocol,
        )}
      />
      <UIButton
        priority="primary"
        title={buttonTitle}
        type="submit"
        isLoading={isLoading}
        disabled={isLoading}
      />
    </div>
  );
};

export default LandingSetTitleForm;
